// extracted by mini-css-extract-plugin
module.exports = {"rating":"groupsGraphItem__rating","item":"groupsGraphItem__item"};